import { pipe } from 'fp-ts/function';
import { fold } from 'fp-ts/lib/Either';
const errorPath = (context) => context
    .filter(({ key }) => !!key)
    .map(({ key }) => key)
    .join('.');
const mapErrorMessagesToPaths = (errors) => {
    return errors
        .map(error => {
        const path = errorPath(error.context);
        return path && error.message ? { [path]: error.message } : {};
    })
        .reduce((obj, item) => {
        return Object.assign(Object.assign({}, obj), item);
    }, {});
};
export const fieldErrorsOrUndefined = (codec, values) => pipe(values, values => codec.decode(values), fold(errors => {
    const mappedErrors = mapErrorMessagesToPaths(errors);
    return Object.keys(mappedErrors).length > 0
        ? mappedErrors
        : undefined;
}, () => undefined));
